import { MissionResponseData } from '../openapi'
import { toSiteAliasSlug } from '../components/preview/previewDisplayMode'

/**
 * license の体験ステージ。Stg1 の教材（RJF01）を配信しているのは num 1 だけ。
 * プレビュー可否の判定（components/preview/previewDisplayMode.ts）と同じ条件で、
 * 片方だけ許可されて「プレビューは出せるのに端末ガードで弾かれる」状態を作らない。
 */
const LICENSE_TRIAL_SLUG = 'rj1_trial'

/**
 * Stg1 の第 1 ミッション（RJF01）か。ProjectProvider がミッション定義を解決する
 * のと同じく、slug をミッション自身のサイトのキー空間に寄せて判定する（online の
 * rjf/rj1 は rb1、license の rj1 は rj1 のまま）。license の通常ステージには
 * rj1_1 が同梱されていないため対象外になる。
 */
export const isStage1TutorialMission = (
  missionInfo: MissionResponseData | undefined,
): boolean =>
  missionInfo?.num === 1 &&
  toSiteAliasSlug(missionInfo.slug, missionInfo.siteName ?? '') === 'rb1'

/**
 * タブレットで利用を許可するミッションか（チュートリアル対象＝第1ミッション）。
 *
 * タブレット（iPad 等）はチュートリアル対象ミッションに限りエディタを利用できる。
 * 対象は Stg1 の第 1（{@link isStage1TutorialMission}）と、同じ RJF01 を配信している
 * license の体験ステージ（rj1_trial の第1）。いずれもおためしプレイで完結でき、
 * Roblox Studio が使えないタブレットでも成立する。
 *
 * リミックス（コピー）でも内容はチュートリアルミッションのままなので、コピーを除外
 * する `isTutorialMission` とは分け、isCopy を見ずに slug/num/siteName で判定する。
 */
export const isTabletSupportedMission = (
  missionInfo: MissionResponseData | undefined,
): boolean => {
  const slug = missionInfo?.slug?.trim().toLowerCase() ?? ''
  return (
    isStage1TutorialMission(missionInfo) ||
    (slug === LICENSE_TRIAL_SLUG && missionInfo?.num === 1)
  )
}
